import App from 'App';
import 'App.css';
import ErrorBoundary from 'ErrorBoundary';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import * as serviceWorker from 'serviceWorker';
import {persistor, store} from 'store';
import {initializeDatadog} from 'utils/datadog';

// your store setup

// Initialize Datadog - this will automatically set up global error handlers
initializeDatadog();

const root = createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <ErrorBoundary
      componentName="App"
      showErrorMessage={false}
      showDetails={process.env.NODE_ENV === 'development'}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// expose store when run in Cypress
if (window.Cypress) {
  // Attaching store to window
  window.store = store;
  window.persistor = persistor;
}
